import { IconSVG } from '../types';

export const Mail = ({ size, style }: IconSVG) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    style={style}
    fill="none"
    viewBox="0 0 24 24"
    >
      <path
        stroke="#1E1E1E"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
        d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2m20 0v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6m20 0-10 7L2 6"
      />
    </svg>
  );
};
